import React, { useState, useEffect } from 'react'
import getCountries from '../../../locale/countries'
import useLocale from '../../../hooks/useLocale'
import Select from '../../../components/Select/Select'
import { useIntl } from 'react-intl'
import messages from '../messages'

type Country = {
  code: string
  name: string
}

const CountrySelect = ({ ...props }) => {
  const { formatMessage } = useIntl()
  const [topCountries, setTopCountries] = useState<Array<Country>>([])
  const [allCountries, setAllCountries] = useState<Array<Country>>([])
  let { language } = useLocale()

  if (['no', 'nn'].includes(language)) {
    language = 'nb'
  }

  useEffect(() => {
    getCountries(language).then(({ getName, getNames }) => {
      let topCountries = 'CA FR DE NL RU SE GB US'
        .split(' ')
        .map((code) => ({ code, name: getName(code, language) }))

      const names = getNames(language)
      let allCountries = Object.keys(names).map((code) => ({
        name: names[code],
        code,
      }))

      topCountries = topCountries.sort((a, b) =>
        a.name.localeCompare(b.name, language),
      )
      allCountries = allCountries.sort((a, b) =>
        a.name.localeCompare(b.name, language),
      )

      setTopCountries(topCountries)
      setAllCountries(allCountries)
    })
  }, [language])

  if (!allCountries.length) return null

  return (
    <Select autoComplete="country" {...props}>
      <optgroup
        label={formatMessage(messages.UserAccount_CountrySelect_TopCountries)}
      >
        {topCountries.map(({ code, name }) => (
          <option value={code} key={code}>
            {name}
          </option>
        ))}
      </optgroup>
      <optgroup
        label={formatMessage(messages.UserAccount_CountrySelect_AllCountries)}
      >
        {allCountries.map(({ code, name }) => (
          <option value={code} key={code}>
            {name}
          </option>
        ))}
      </optgroup>
    </Select>
  )
}

export default CountrySelect
